/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nutrient_FatInputs */

const en_nutrient_fat = /** @type {(inputs: Nutrient_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fat`)
};

const de_nutrient_fat = /** @type {(inputs: Nutrient_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fett`)
};

/**
* | output |
* | --- |
* | "Fat" |
*
* @param {Nutrient_FatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nutrient_fat = /** @type {((inputs?: Nutrient_FatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nutrient_FatInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nutrient_fat(inputs)
	return en_nutrient_fat(inputs)
});